import * as React from "react";
import Button from "@mui/material/Button";
import DialogProjects from "./DialogProjects";
import project1 from '../assets/img/1440p.PNG';

function Projects() {
  const projectList = [

    {
      imgSrc: "https://i.ibb.co/23PfCFw/Votify.png",
      src: "https://votify-drab.vercel.app/",
      description: "Private Repo. An innovative platform built with Next.js 13, TypeScript, Prisma, MongoDB, and NextAuth. Experience stunning themes, including dark mode, and enjoy seamless Google authentication. Engage with our AI-powered chatbot, driven by Vercel AI SDK and OpenAI Edge. Pro members benefit from limitless event creation, while free members get one event.",
      github: "https://github.com/ayusharma-ctrl/Votify",
    },
    {
      imgSrc: "https://i.ibb.co/pbBd0pN/Airbnb.png",
      src: "https://airent-beta.vercel.app/",
      description: "Built an Airbnb clone using TypeScript, Next.js, Tailwind CSS, Zustand state management, MongoDB, and Prisma for database operations. Implemented NextAuth for versatile authentication with popular providers like Google and GitHub, as well as traditional email-password logins.",
      github: "https://github.com/ayusharma-ctrl/Airbnb",
    },
    {
      imgSrc: "https://i.ibb.co/R4BctQ4/Home.png",
      src: "https://workplace99.netlify.app/",
      description: "Developed a React-Redux application that enables employers to post jobs and hire candidates, and allows candidates to see posted jobs and apply, with a chat feature for real-time conversations between employers and selected candidates. Utilized Material UI for complete responsiveness across all screen sizes, and implemented Firebase authentication and storage for secure storage of user data and files. Employed Firebase Firestore as a NO-SQL database to enable CRUD operations and efficient data management. Implemented Google single sign-on feature for user authentication and ease of use. Implemented private and restricted routes to ensure secure access to sensitive information and features within the application.",
      github: "https://github.com/ayusharma-ctrl/workplace99",
    },
    {
      imgSrc: "https://i.ibb.co/68PwqCT/Blogify.png",
      src: "https://blogify-ayusharma.vercel.app/",
      description: "Blogify is a feature-rich MERN app that enables users to create, share, and engage with blogs. It offers CRUD operations, profile management, token-based email authentication, following functionality, likes and bookmarks, a bin for deleted blogs, comment posting, and real-time updates. With 50+ REST APIs, secure login, and protected routes.",
      github: "https://github.com/ayusharma-ctrl/Blogify",
    },
    {
      imgSrc: "https://i.ibb.co/n71P5LN/NFTify.png",
      src: "https://nftify-rainbow.netlify.app/",
      description: "React app that allows users to explore cryptocurrency tokens and pairs. Users can search for tokens by entering a token/pair address, name, or symbol. The app fetches data from the Dexscreener API to provide real-time information about token prices, and more. Additionally, the app supports cryptocurrency wallet connectivity using Rainbowkit.",
      github: "https://github.com/ayusharma-ctrl/NFTify",
    },

    {
      imgSrc: 'https://i.ibb.co/x7FZCS8/1440p.png',
      src: "https://cinebinge.netlify.app/",
      description: "Developed a responsive web application using React, Material UI, and Bootstrap that allows users to browse and search for details of movies and TV shows. This webapp suggests popular & trending recommendations. Integrated Firebase as a backend authentication and real-time database solution to securely manage user accounts and data. Key highlight is Universal Movie Search Bar.",
      github: "https://github.com/ayusharma-ctrl/Cinebinge",
    },

    {
      imgSrc: "https://i.postimg.cc/qM67yRkg/img.jpg",
      src: "https://quickpick.onrender.com/",
      description: "Built a React Native mobile app(e-commerce grocery) with backend RestAPIs using Node.js, Express, and MongoDB. Users can create an account, authenticate using email OTP, view and filter products, add products to the cart, apply a coupon, and place orders. The admin can update the order status, add products to the app, and edit product information.",
      github: "https://github.com/ayusharma-ctrl/Quickpick-Fullstack-ReactNative-Nodejs-Express-MongoDB",
    },

    // {
    //   imgSrc:
    //     "https://i.ibb.co/7QFwLD6/Screenshot-2021-12-09-at-2-27-09-PM.png",
    //   src: "https://pizzacassino-pixysquare.vercel.app/",
    //   description: "A website for a Pizza Restaurant in New Delhi, India",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/2WNgr8q/Screenshot-2022-01-03-at-9-31-15-PM.png",
    //   src: "https://www.wexus.in/",
    //   description:
    //     "The new website for Simply Sites. A Freelancing service started by me and Jayesh Sadhwani where we provide 3 tiers of services to build responsive and clean webapps with full fledged backend support.",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/BwPrB9k/Screenshot-2022-01-08-at-1-20-52-AM.png",
    //   src: "https://www.drishtimakhijani.com/",
    //   description: "Portfolio made for @Drishti Makhijani , 2022",
    //   github: false,
    // },

    // {
    //   imgSrc:
    //     "https://i.ibb.co/PMts9RD/Screenshot-2021-12-09-at-1-39-01-PM.png",
    //   src: "https://www.anonimo.fun",
    //   description:
    //     "An anonymous chatting and inboxing website made from scratch using Next JS and Firebase",
    //   github: "https://github.com/AVIVASHISHTA29/anonimofinal-1",
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/gmrSfPc/Screenshot-2021-12-09-at-2-21-22-PM.png",
    //   src: "https://www.simplysites.tech/",
    //   description:
    //     "A Freelancing service started by me and Jayesh Sadhwani where we provide 3 tiers of services to build responsive and clean webapps with full fledged backend support.</p>",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/9cv22Ds/Screenshot-2021-12-09-at-2-06-54-PM.png",
    //   src: "https://valiance.in",
    //   description:
    //     "We design and develop themes for customers of all sizes, specializing in creating stylish, modern websites, web portfolios and e-commerce stores. We create a website that stands out.      ",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/drZBgZ8/Screenshot-2021-12-09-at-2-16-57-PM.png",
    //   src: "https://anchor.fm/lockdown-wars",
    //   description:
    //     "Lockdown Wars is a podcast made specially for you to spend your lonely and depressed time! We come with a platform for all of your relateable Quarantine content! Share your lockdown stories with us! This is Lockdown wars! Where your stories are heard.",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/xX3CnB1/Screenshot-2021-12-09-at-2-22-01-PM.png",
    //   src: "https://baremolecules.myshopify.com/",
    //   description: "A Shopify Skin Care Brand.",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/3B9zkvg/Screenshot-2021-12-09-at-2-12-55-PM.png",
    //   src: "https://www.sukoonngo.com",
    //   description:
    //     "Youth, the part which represents future, but is still neglected. Sukoon is an organization which aims to change that. We at Simply Sites helped them reach a wider audience with a beautiful website",
    //   github: false,
    // },

    // {
    //   imgSrc:
    //     "https://i.ibb.co/YDgQB2g/Screenshot-2021-12-09-at-1-49-54-PM.png",
    //   src: "https://avivashishta.wixsite.com/mybooks",
    //   description: "My Online Book store, made using Wix.",
    //   github: false,
    // },

    // {
    //   imgSrc:
    //     "https://i.ibb.co/CQqDVh0/Screenshot-2021-12-09-at-1-50-56-PM.png",
    //   src: "https://avivashishta.wixsite.com/easylife-copy",
    //   description:
    //     "A freelancing project taken up in early 2020 - An online grocery store made using wix with online payment functionality.",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/MVy7w5Z/Screenshot-2021-12-09-at-1-56-58-PM.png",
    //   src: "https://avivashishta.wixsite.com/simplemenus",
    //   description:
    //     "A Startup which Aims to completely digitize restaurant menus by providing custom designed QR Code templates and Stands to Restaurants and Eateries in New Delhi.",
    //   github: false,
    // },
    // {
    //   imgSrc:
    //     "https://i.ibb.co/0s0qRtq/Screenshot-2021-12-09-at-2-10-34-PM.png",
    //   src: "https://avivashishta.wixsite.com/infiniterider",
    //   description:
    //     "Infinite Rider is a Game which takes Flappy Based Games to the Next level. We have introduced Spaceships and a new Axis. Yes! You can now control the player in 3D. Enabling movement in the x, y and z coordinate",
    //   github: false,
    // },
  ];

  return (
    <div id="projects">
      <h1>
        Projects <strong style={{ color: "#006AFF" }}>.</strong>
      </h1>
      <div className="projectsDiv">
        {projectList.map((data) => {
          return (
            <DialogProjects
              src={data.src}
              imgSrc={data.imgSrc}
              description={data.description}
              github={data.github}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Projects;
